import { render, staticRenderFns } from "./TabsNavItem.vue?vue&type=template&id=d2cdc9be"
import script from "./TabsNavItem.vue?vue&type=script&lang=js"
export * from "./TabsNavItem.vue?vue&type=script&lang=js"
import style0 from "./TabsNavItem.vue?vue&type=style&index=0&id=d2cdc9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports